module.exports = __webpack_public_path__ + "img/1-cartoon.0c086f05.jpg";